import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ensureMsalInitialized, msalInstance } from '@/lib/auth/msalInstance';
import { router } from './router';

// Inicialização explícita do MSAL (obrigatória em @azure/msal-browser ≥ 3).
// Em background; falhas são logadas no console.
ensureMsalInitialized().catch((err) => {
  console.error('MSAL initialize failed', err);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Composição raiz: MSAL (auth) + TanStack Query (server state) + TanStack Router (navegação).
 * O shell (sidebar + topbar) e o gate de autenticação vivem na rota raiz
 * (src/routes/__root.tsx) — Épico E4.
 */
function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </MsalProvider>
  );
}

export default App;
